module.exports = __webpack_public_path__ + "static/media/law_in_hand_5.5d08ec93.jpg";